import { render, staticRenderFns } from "./TopKeywordsFilter.vue?vue&type=template&id=025d2251&scoped=true"
import script from "./TopKeywordsFilter.vue?vue&type=script&lang=js"
export * from "./TopKeywordsFilter.vue?vue&type=script&lang=js"
import style0 from "./TopKeywordsFilter.vue?vue&type=style&index=0&id=025d2251&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025d2251",
  null
  
)

export default component.exports